"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const NavigationMobile = ({ title, onMenuClick, onTitleClick, rightSection, className }) => {
    return ((0, jsx_runtime_1.jsxs)(Navigation, { className: className, children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", onClick: onMenuClick, size: "2x", icon: ["fal", "bars"] }, void 0), (0, jsx_runtime_1.jsx)("div", { "data-cy": "bottom-nav-name", onClick: onTitleClick, children: (0, jsx_runtime_1.jsxs)(typography_1.H2, { children: [onTitleClick && (0, jsx_runtime_1.jsx)("a", { children: title }, void 0), !onTitleClick && title] }, void 0) }, void 0), rightSection ? rightSection : (0, jsx_runtime_1.jsx)("div", {}, void 0)] }, void 0));
};
exports.NavigationMobile = NavigationMobile;
const Navigation = styled_components_1.default.nav `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  display: flex;
  height: 100%;
  max-height: 50px;
  justify-content: space-between;
  padding: ${({ theme }) => `0 ${theme.spacings.m}`};
  width: 100%;

  & > div {
    align-items: center;
    display: flex;
    flex: 1;
    height: 100%;
    justify-content: flex-start;
  }

  & > div:first-of-type svg {
    font-size: 1.7rem;
    height: 1.5rem;
  }

  & > div:nth-of-type(2) {
    flex: 6;
    justify-content: center;
  }

  & > div:last-of-type {
    justify-content: flex-end;
  }

  h2 {
    margin: 0;
    text-align: center;
    text-overflow: ellipsis;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    max-width: 80%;
  }

  & > div:nth-of-type(3) svg {
    font-size: 1.3rem;
  }
  svg {
    cursor: pointer;
    font-size: 1.25rem;
  }
`;
//# sourceMappingURL=mobile.js.map